const getIds = obj =>
    Object.entries(obj)
        .filter(([, isPresent]) => isPresent)
        .map(([id]) => id);

export default getIds;
